import React from "react";
import styled, { css } from "react-emotion";

const StyledDeal = styled("div")`
  color: black;
  width: 100%;
  background: #6edb97;
  box-sizing: content-box;
  border-radius: 5px;
  text-align: center;
  margin: ${(props) => (props.margin ? props.margin : "5 0 5 0")};
  background: ${(props) => (props.background ? props.background : "white")};
  border: ${(props) => "1px solid " + props.color};
  padding: 10px 0px;
  margin: 10px;
`;

const smallText = css`
  font-size: 9px;
  height: auto;
  color: black;
`;

const finePrintStyle = css`
  font-size: 12px;
  word-wrap: break-word;
  color: black;
  margin: 10px;
`;

const descriptionStyle = css`
  color: black;
  /* word-wrap: break-word; */
`;

const Deal = (props) => {
  const {
    id,
    title,
    description,
    expiration,
    maxUses,
    finePrint,
    retired,
    margin,
    barColor,
    numberOfUsesRemainingForUser,
    isAnonUser,
  } = props;
  const parsedExpiration = new Date(expiration).toLocaleDateString("en-US");

  return (
    <StyledDeal key={id} margin={margin} color={barColor}>
      <h2 style={{ color: "black" }}>{title}</h2>
      {description ? (
        <p className={descriptionStyle}>{description}</p>
      ) : (
        <p className={descriptionStyle}></p>
      )}

      {finePrint ? (
        <p className={finePrintStyle}>Fine Print: {finePrint}</p>
      ) : (
        <p className={finePrintStyle}></p>
      )}
      <div>
        {maxUses && !expiration ? (
          <p className={smallText}>
            Remaining Uses :{" "}
            {isAnonUser ? maxUses : numberOfUsesRemainingForUser}
          </p>
        ) : (
          <p className={smallText}></p>
        )}

        {maxUses && expiration ? (
          <p className={smallText}>
            Expires: {parsedExpiration} | Remaining Uses :{" "}
            {isAnonUser ? maxUses : numberOfUsesRemainingForUser}
          </p>
        ) : null}
        {!maxUses && expiration ? (
          <p className={smallText}>Expires: {parsedExpiration}</p>
        ) : null}
      </div>
    </StyledDeal>
  );
};

export default Deal;
